export default __webpack_public_path__ + "e6e992c310cd70e8e30a4989f37b8c54.png";